export enum EXPLORER {
  MEMPOOL = 'Mempool',
  BLOCK_STREAM = 'Blockstream',
}
